import { render, staticRenderFns } from "./FooterWeb.vue?vue&type=template&id=625bc1c8&"
import script from "./FooterWeb.vue?vue&type=script&lang=js&"
export * from "./FooterWeb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports